import stickySideNav from './stickySideNav.js';
import learnLibrariesNavActiveState from './learnLibrariesNavActiveState.js';

const learnLibraries = {
    init: function () {
        const videoComponents = document.querySelectorAll('.media-component .video-wrapper');

        learnLibrariesNavActiveState.init();
        stickySideNav.init();

        if (videoComponents) {
            import('./mediaVideo.js').then(({default: mediaVideo}) => mediaVideo.init(videoComponents));
        }
    }
};

export default learnLibraries;
